import { render, staticRenderFns } from "./beforeLogin.vue?vue&type=template&id=730af108&"
import script from "./beforeLogin.vue?vue&type=script&lang=js&"
export * from "./beforeLogin.vue?vue&type=script&lang=js&"
import style0 from "./beforeLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730af108')) {
      api.createRecord('730af108', component.options)
    } else {
      api.reload('730af108', component.options)
    }
    module.hot.accept("./beforeLogin.vue?vue&type=template&id=730af108&", function () {
      api.rerender('730af108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/beforeLogin.vue"
export default component.exports